// extracted by mini-css-extract-plugin
export default {"container":"projection_container__1fMFt","image":"projection_image__3Vn1X","title":"projection_title__2ac6c","films":"projection_films__2Rctg","date":"projection_date__3x2NT"};